import NotApplicable from './NotApplicable';

export default NotApplicable;
